import {
  UPDATE_STORE_LOCATOR,
  UPDATE_ALTERNATIVE_STORE,
  UPDATE_CIS_COOKIE_STATUS
} from '../../actionTypes/storeLocatorActionTypes'

const updateStoreLocator = payload => ({
  type: UPDATE_STORE_LOCATOR,
  payload
})

const updateAlternativeStoreState = payload => ({
  type: UPDATE_ALTERNATIVE_STORE,
  payload
})

const updateCisCookieStatus = payload => ({
  type: UPDATE_CIS_COOKIE_STATUS,
  payload
})

export { updateStoreLocator, updateAlternativeStoreState, updateCisCookieStatus }
